import React, { useState } from "react"
import styled from "styled-components"

import { breakpoints } from "../parameters/theme"

const Container = styled.div`
  background: #f6f6f6;
  margin-bottom: 2em;
  margin-top: 2em !important;
  padding: 1em;

  .input {
    display: grid;
    grid-auto-rows: 1fr;
    grid-gap: 1em 1em;
    grid-template-columns: 5fr 1fr 5fr;

    input,
    select {
      font-size: 0.8em;
      height: 3em;
      padding: 0 1em;
      width: 100%;
    }

    input {
      -moz-appearance: textfield;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    span {
      padding: 1em 0;
      text-align: center;
    }
  }

  .result {
    margin-top: 1em;
    text-align: center;
    font-size: 2em;

    .empty {
      font-style: italic;
    }
  }

  .extra-result {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin-top: 1em;
  }

  .error {
    background: #eecccc;
    color: #666666;
    font-size: 0.8em;
    padding: 0.5em;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .extra-result {
      .xrm {
        flex-basis: 33%;
        margin-top: 1em;
        text-align: center;

        &:nth-child(1) {
          order: 1;
        }
        &:nth-child(2) {
          order: 4;
        }
        &:nth-child(3) {
          order: 7;
        }
        &:nth-child(4) {
          order: 2;
        }
        &:nth-child(5) {
          order: 5;
        }
        &:nth-child(6) {
          order: 8;
        }
        &:nth-child(7) {
          order: 3;
        }
        &:nth-child(8) {
          order: 6;
        }
        &:nth-child(9) {
          order: 9;
        }
      }
    }
  }
`

const ORMCalculator = props => {
  const [data, setData] = useState({
    reps: "",
    weight: "",
    orm: 0,
    error: "",
  })

  const updateORM = options => {
    options = options ? options : {}

    setData(currentData => {
      const newData = { ...currentData, ...options, orm: 0, error: "" }

      if (
        !newData.weight ||
        !newData.reps ||
        isNaN(newData.weight) ||
        isNaN(newData.reps)
      ) {
        return newData
      }

      if (newData.reps && 10 < newData.reps) {
        newData.error = "Reps above 10 yields inaccurate results"
      }

      newData.orm = newData.weight / (1.0278 - 0.0278 * newData.reps)

      return newData
    })
  }

  const round = value => {
    return Math.round(value)
  }

  const handleInputChange = e => {
    const prop = e.currentTarget.name

    updateORM({
      [prop]: e.currentTarget.value,
    })
  }

  return (
    <Container id="orm-calculator">
      <div className="input">
        <input
          type="number"
          value={data.weight}
          onChange={handleInputChange}
          name="weight"
          placeholder="weight"
        />
        <span>×</span>
        <input
          type="number"
          value={data.reps}
          onChange={handleInputChange}
          name="reps"
          placeholder="reps"
        />
      </div>
      {data.error ? <p className="error">{data.error}</p> : ""}
      <div className="result">
        {data.orm ? (
          <p className="orm">1×{round(data.orm)}</p>
        ) : (
          <p className="empty">Enter your numbers above</p>
        )}
      </div>
      {data.orm ? (
        <div className="extra-result">
          <p className="xrm">2×{round((data.orm * (37 - 2)) / 36)}</p>
          <p className="xrm">3×{round((data.orm * (37 - 3)) / 36)}</p>
          <p className="xrm">4×{round((data.orm * (37 - 4)) / 36)}</p>
          <p className="xrm">5×{round((data.orm * (37 - 5)) / 36)} </p>
          <p className="xrm">6×{round((data.orm * (37 - 6)) / 36)} </p>
          <p className="xrm">7×{round((data.orm * (37 - 7)) / 36)} </p>
          <p className="xrm">8×{round((data.orm * (37 - 8)) / 36)} </p>
          <p className="xrm">9×{round((data.orm * (37 - 9)) / 36)}</p>
          <p className="xrm">10×{round((data.orm * (37 - 10)) / 36)} </p>
        </div>
      ) : (
        ""
      )}
    </Container>
  )
}

export default ORMCalculator
